/* tslint:disable */
/* eslint-disable */
/**
 * OpenAPI definition
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import { mapValues } from '../runtime';
import type { CompanySearchResultResource } from './';
import {
    CompanySearchResultResourceFromJSON,
    CompanySearchResultResourceFromJSONTyped,
    CompanySearchResultResourceToJSON,
} from './';

/**
 * 
 * @export
 * @interface CompanySearchResource
 */
export interface CompanySearchResource {
    /**
     * 
     * @type {Array<CompanySearchResultResource>}
     * @memberof CompanySearchResource
     */
    companies: Array<CompanySearchResultResource>;
}

/**
 * Check if a given object implements the CompanySearchResource interface.
 */
export function instanceOfCompanySearchResource(value: object): value is CompanySearchResource {
    if (!('companies' in value) || value['companies'] === undefined) return false;
    return true;
}

export function CompanySearchResourceFromJSON(json: any): CompanySearchResource {
    return CompanySearchResourceFromJSONTyped(json, false);
}

export function CompanySearchResourceFromJSONTyped(json: any, ignoreDiscriminator: boolean): CompanySearchResource {
    if (json == null) {
        return json;
    }
    return {
        
        'companies': ((json['companies'] as Array<any>).map(CompanySearchResultResourceFromJSON)),
    };
}

export function CompanySearchResourceToJSON(value?: CompanySearchResource | null): any {
    if (value == null) {
        return value;
    }
    return {
        
        'companies': ((value['companies'] as Array<any>).map((v) => CompanySearchResultResourceToJSON(v))),
    };
}

